/* @flow */
/*jshint esversion: 6 */
import React from "react";
import ReactDOM from "react-dom";
import { Menu, Icon, Badge } from "antd";
import { withRouter } from "react-router-dom";
import TableIDs from "../data/TableIDs";
import LangContext from "../contextProvider/LangContext"

const SubMenu = Menu.SubMenu;

type History = {
    push: Function,
    location: {
        pathname: string
    }
};

type Props = {
    history: History,
    baseUrl: string
};

type State = {
  menuTag: any,
  menuItemsTop: Array<Object>,
  menuItemsDrop: Array<Object>
};

class ReportMenu extends React.Component<Props, State> {
    myHistory: History;
    baseUrl: string;

    constructor(props:Props) {
        super(props);
        this.myHistory = this.props.history;
        this.baseUrl = this.props.baseUrl;

        if (props.data[TableIDs.pseudoSelectorUIcomponentsModules] === undefined) {
            props.data[TableIDs.pseudoSelectorUIcomponentsModules] = { ...props.data.genericSelector };
        }

        this.state = {
            menuTag: (<div></div>),
            menuItemsTop: [
                { KeyComp: "61", key: "payments-daily", text: "תקבולים - יומי", keyLang: 10189, icon: "file" },
                { KeyComp: "62", key: "payments-monthly", text: "תקבולים - חודשי", keyLang: 10190, icon: "file" },
                { KeyComp: "63", key: "payment-aggregate", text: "תקבולים - סיכום", keyLang: 10191, icon: "file" },
                { KeyComp: "64", key: "payment-detailed", text: "תקבולים - מפורט", keyLang: 10192, icon: "file" },
                { KeyComp: "65", key: "payments-shva", text: "שידורי שב\"א", keyLang: 10193, icon: "file" },
                { KeyComp: "168", key: "transactions", text: "שוברי אשראי", keyLang: 16909, icon: "credit-card" },
                { KeyComp: "169", key: "credit-card-payments", text: "עסקאות אשראי", keyLang: 21708, icon: "credit-card" },
                { KeyComp: "67", key: "payments-creditCard", text: "פירוט עסקאות אשראי", keyLang: 10195, icon: "file" },
                { KeyComp: "66", key: "payments-checks", text: "דוח פירוט שקים", keyLang: 10194, icon: "file" },
                { KeyComp: "69", key: "payments-z-report", text: "פירוט לפי דוח Z", keyLang: 10196, icon: "file" },
                { KeyComp: "70", key: "payments-refunds", text: "דוח שוברי זיכוי", keyLang: 12767, icon: "file" },
                { KeyComp: "161", key: "pos-turnover", text: "סיכום פדיון לקופה", keyLang: 14250, icon: "file" },
                { KeyComp: "162", key: "payments-analysis", text: "ניתוח תקבולים ריכוזי", keyLang: 14584, icon: "bar-chart" },
                { KeyComp: "163", key: "catering-tickets", text: "כרטיסי הסעדה", keyLang: 14629, icon: "file" },
                { KeyComp: "164", key: "accounting-branches", text: "התחשבנות מול סניפים", keyLang: 15673, icon: "cluster" },
                { KeyComp: "165", key: "gift-card-report", text: "כרטיסי מתנה", keyLang: 15950, icon: "gift" },
                { KeyComp: "166", key: "branch-admin-summary", text: "דוח מנהלים סניפי", keyLang: 21183, icon: "table" },
                { KeyComp: "167", key: "dynamic-receipt-display", text: "תצוגת תקבולים דינמית", keyLang: 21282, icon: "area-chart" },
                { KeyComp: "170", key: "payments-and-sales", text: "ריכוז תקבולים ומכירות לתקופה", keyLang: 21745, icon: "block" },
            ].filter((menuItem, index) => this.isActive(menuItem.KeyComp)),
            menuItemsDrop: []
        };
    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    isActive = (key) => {
        return this.props.data[TableIDs.pseudoSelectorUIcomponentsModules].dataset
            .map(obj => obj.code).includes(key);
    };

    onMenuSelect(args) {
        this.myHistory.push(
            this.baseUrl + "/reports_payments/" + (args.key !== "home" ? args.key : ""),
            {}
        );
    }

    updatePriorityMenu = () => {
        let maxHeight = 50; //px
        let _height = -1;
        let firstIter = true;

        let listTop = this.state.menuItemsTop;
        let listDrop = this.state.menuItemsDrop;
        // re-populate menu
        for (let i = 0; i < listDrop.length; i++) {
            listTop.push(listDrop.pop());
        }

        //ReactDOM.findDOMNode(this).clientHeight;
        while (_height > maxHeight || _height < 0) {
            //this.state.menuItemsDrop.push(this.state.menuItemsTop.pop());
            if (!firstIter) {
                this.state.menuItemsDrop.push(this.state.menuItemsTop.pop());
            }
            else {
                firstIter = false;
            }
            this.setState((prevState, props) => {
                return {
                    menuTag: <Menu
                        mode="horizontal"
                        defaultSelectedKeys={[
                            this.myHistory.location.pathname.split(this.baseUrl).join("").split("/")[2] || "home"
                        ]}
                        onSelect={this.onMenuSelect.bind(this)}
                    >
                        {this.renderMenuItemsTop()}
                        <SubMenu title={<Badge count={listDrop.length}><Icon type="ellipsis" /></Badge>}>
                            {this.renderMenuItemsDrop()}
                        </SubMenu>
                    </Menu>
                }
            });
            console.log("findDomNode report menu payments: ",(this) ? "true" : "false", this);
            let e:Element|null|Text = ReactDOM.findDOMNode(this);
            _height = (e instanceof HTMLElement) ? e.clientHeight : 0;
            //alert(_height);
        }
    }

    renderMenuItemsTop() {
        let res = [];
        let list = this.state.menuItemsTop;
        if (list.length > 0) {
            for (let item of list) {
                res.push(
                    <Menu.Item key={item.key}>
                        <Icon type={item.icon} className="menu-icon" />
                        <span>{item.keyLang ? this.getText(item.keyLang) : ""}</span>
                    </Menu.Item>);
            }
            return res;
        }
    }
    
    renderMenuItemsDrop() {
        let res = [];
        let list = this.state.menuItemsDrop;
        if (list.length > 0) {
            for (let item of list) {
                res.push(
                    <Menu.Item key={item.key}>
                        <Icon type={item.icon} className="menu-icon" />
                        <span>{item.keyLang ? this.getText(item.keyLang) : ""}</span>
                    </Menu.Item>);
            }
        }
        return res;
    }

    doUpdateOfPriorityMenu = () => {
        setTimeout(this.updatePriorityMenu);
    };

    // Add event listener
    componentDidMount() {
        setTimeout(this.updatePriorityMenu);
        //window.addEventListener("resize", this.updatePriorityMenu);
        window.addEventListener("resize", this.doUpdateOfPriorityMenu );
    }

    // Remove event listener
    componentWillUnmount() {
        //window.removeEventListener("resize", this.updatePriorityMenu);
        window.removeEventListener("resize", this.doUpdateOfPriorityMenu);
    }

    render() {
        return this.state.menuTag;
    }
}

export default withRouter(ReportMenu);
